var render, staticRenderFns
import script from "./c_divider.vue?vue&type=script&lang=js"
export * from "./c_divider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5520105c",
  null
  
)

/* custom blocks */
import block0 from "./c_divider.vue?vue&type=custom&index=0&blockType=div&class=borderPadding"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城商家端\\fhj-web-dyh-mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5520105c')) {
      api.createRecord('5520105c', component.options)
    } else {
      api.reload('5520105c', component.options)
    }
    
  }
}
component.options.__file = "src/components/PageDiy/mobileConfigRight/c_divider.vue"
export default component.exports